import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

// Fills in the org invite preview modal and opens it. Subject and body are
// rendered server-side from OrganizationInvites::EmailContent, so this only
// carries the invitee across: the visible address plus the hidden fields the
// Send invite form posts.
export default class extends Controller {
    static targets = ["emailInput", "roleSelect", "previewEmail", "hiddenEmail", "hiddenRole", "modal"]

    open() {
        const email = (this.emailInputTarget.value || "").trim()
        // The modal opens from here rather than data-bs-toggle so a blank or
        // invalid address can't reach the form and post an empty invite.
        if (!email || !this.emailInputTarget.checkValidity()) {
            this.emailInputTarget.reportValidity()
            return
        }

        const role = this.hasRoleSelectTarget ? this.roleSelectTarget.value : "member"

        this.previewEmailTarget.textContent = email
        this.hiddenEmailTarget.value = email
        if (this.hasHiddenRoleTarget) this.hiddenRoleTarget.value = role

        bootstrap.Modal.getOrCreateInstance(this.modalTarget).show()
    }
}
